import {Button, ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import React, {useState} from "react";
import './roundedDropdown.scss';
export function RoundedDropdown({btnColor = 'info', btnText, itemList, onSelect}) {
	const [isOpen, setIsOpen] = useState(false);

	function closeDropdown() {
		setIsOpen(false);
	}

	function toggleOpen() {

	  setIsOpen(prev => !prev);

	}

	return (
		<>
			<Dropdown direction="up" toggle={toggleOpen} isOpen={isOpen}>
        <DropdownToggle caret  color={btnColor} className="dropbtn">
          {btnText}
        </DropdownToggle>
					<DropdownMenu className="dropdown-session-content">
						{itemList.map(item => {
							return <DropdownItem key={item} onClick={() => onSelect(item.toLowerCase())}>
                {item}
							</DropdownItem>
						})}
					</DropdownMenu>
			</Dropdown>
		</>
	);
};
